import _ from 'lodash'
import Backbone from 'backbone'
import template from './current-filters-panel.hbs'
import EditableFilterBadges from './filter/editable-report-filter-badges'
import InitiativeReportFilterMeta from 'scoreboard/reports/wizard/initiative-report/initiative-filter-meta'
import ScorecardFilterMeta from 'scoreboard/reports/wizard/filter-meta/scorecard-filter-meta'
import i18n from 'scoreboard/components/i18n'
import formatValue from 'scoreboard/components/format-value'
import DataType from 'scoreboard/datasets/model/data-type'
const { NUMBER } = DataType

const reportSubtypeMetaInfo = {
	'initiative-report' : {
		meta: InitiativeReportFilterMeta,
		totalMessageCodePrefix: 'report.designer.initiative'
	},
	'initiative-report-designer' : {
		meta: InitiativeReportFilterMeta,
		totalMessageCodePrefix: 'report.designer.initiative'
	},
	'scorecard-report-designer' : {
		meta: ScorecardFilterMeta,
		totalMessageCodePrefix: 'report.designer.scorecard'
	}
}

/**
 * Current filters panel for reports
 */
const CurrentFilters = Backbone.View.extend({

	events: {
		'click .add': 'addFilter'
	},

	initialize(options = {}) {
		this.options = options
		if (_.isNil(reportSubtypeMetaInfo[this.options.type])) {
			throw new Error('Unsupported report type')	//this is a programming error
		}
		_.assign(this, reportSubtypeMetaInfo[this.options.type])
	},

	render() {
		let {model, meta} = this

		let templateCtx = _.assign({}, this.options)
		this.$el.html(template(templateCtx))

		this.badgeView && this.badgeView.remove()
		this.badgeView = new EditableFilterBadges({
			model,
			meta,
			showProjectSelector: _.get(this.options, 'showProjectSelector', false)
		})
		this.badgeView.on('delete', () => this.trigger('deleteFilter'))
		this.$('.current-filters').html(this.badgeView.el)
		this.badgeView.render()
		this.listenTo(this.badgeView, 'change delete', () => { this.trigger('change') })
		return this
	},

	renderShowingXRecords: function(meta) {
		let {numResults, totalCount} = meta
		if (!isNaN(totalCount) && !isNaN(numResults)) {
			let messageCode = this.totalMessageCodePrefix +
				(totalCount === numResults ? '.showingAll' : '.showingSomeOfTotal')
			const format = value => formatValue({
				value,
				dataType: NUMBER
			})
			const formattedNumResults = format(numResults)
			const formattedTotalCount = format(totalCount)
			this.$('.showing-x-records')
				.removeClass('is-not-displayed')
				.html(i18n.get(messageCode, formattedNumResults, formattedTotalCount))
		} else {
			this.$('.showing-x-records').addClass('is-not-displayed')
		}
	},

	addFilter(e) {
		this.trigger('addFilter')
	},

	remove() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.badgeView], 'remove')
	}

})

export default CurrentFilters
CurrentFilters.__filename__ = 'reports/common/current-filters.js'
